module.exports = __webpack_public_path__ + "660b10fb5e9c7685bb4f2359900fbbea.svg";